import { money } from "@/lib/api";
import { EmptyState } from "@/components/shared";
import { Building2, Eye, EyeOff, Trash2 } from "lucide-react";

export const ListingsTab = ({ adminProps, onToggleVisibility, onDelete }) => (
  <>
    <div className="flex items-center justify-between mb-4">
      <div>
        <h2 className="text-xl font-heading font-medium text-ink">All Listings</h2>
        <p className="text-sm text-mute mt-1">Hide a listing from the public Browse page, restore it, or permanently delete it. Deleting also removes its applications, showings, leases, maintenance and expense records.</p>
      </div>
    </div>
    {adminProps.length === 0 ? (
      <div className="bg-white border border-line rounded-xl"><EmptyState icon={Building2} title="No listings" /></div>
    ) : (
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {adminProps.map((p) => (
          <div key={p.id} data-testid={`admin-prop-${p.id}`} className="bg-white border border-line rounded-xl overflow-hidden">
            <div className="relative">
              <img src={p.images?.[0] || "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=85"} alt="" className={`h-40 w-full object-cover ${p.hidden ? "opacity-60" : ""}`} />
              {p.hidden && (
                <span data-testid={`admin-hidden-badge-${p.id}`} className="absolute top-2 left-2 inline-flex items-center gap-1 rounded-full bg-ink/85 text-white px-2.5 py-0.5 text-xs font-semibold"><EyeOff className="h-3 w-3" /> Hidden</span>
              )}
            </div>
            <div className="p-4">
              <h3 className="font-heading font-medium text-ink truncate">{p.title}</h3>
              <p className="text-sm text-mute">{p.landlord_name || "—"} · {p.city}, {p.state}</p>
              <p className="mt-1 font-semibold text-forest">{money(p.monthly_rent)}/mo</p>
              {p.has_signed_lease && <span data-testid={`admin-signed-badge-${p.id}`} className="mt-1 inline-block text-[11px] font-semibold text-forest bg-forest/10 rounded-full px-2 py-0.5">Signed lease</span>}
              {p.hidden ? (
                <button data-testid={`admin-unhide-prop-${p.id}`} onClick={() => onToggleVisibility(p)} className="mt-3 w-full border border-forest text-forest rounded-lg py-1.5 text-sm hover:bg-forest/5 flex items-center justify-center gap-1.5"><Eye className="h-3.5 w-3.5" /> Unhide (show on Browse)</button>
              ) : (
                <button data-testid={`admin-hide-prop-${p.id}`} onClick={() => onToggleVisibility(p)} className="mt-3 w-full border border-line text-ink rounded-lg py-1.5 text-sm hover:bg-bone flex items-center justify-center gap-1.5"><EyeOff className="h-3.5 w-3.5" /> Hide from Browse</button>
              )}
              <button data-testid={`admin-delete-prop-${p.id}`} onClick={() => onDelete(p)} className="mt-2 w-full border border-terracotta/40 text-terracotta rounded-lg py-1.5 text-sm hover:bg-terracotta/5 flex items-center justify-center gap-1.5"><Trash2 className="h-3.5 w-3.5" /> Delete listing</button>
            </div>
          </div>
        ))}
      </div>
    )}
  </>
);
